import React from 'react';

import Helpers from './helpers.jsx';
import Setting from './setting.jsx';

import RepeatableRegion from './repeatable_region.jsx'

import Resolver from '../component_resolver.jsx'
import { resolveComponentProps } from '../form_viewer.jsx';

export default class AdaliaMEExternalEntityArray extends RepeatableRegion {

  static get TYPE() {
    return 'adalia_me_external_entity_array';
  }

  static icon(){
      return <i className="fa fa-bars"></i>;
  }

  static dropComponent(dropArea, targetContent, droppedContent, components, isNested) {
    // Pass content from parent
    droppedContent.endpoint = targetContent.endpoint;
    droppedContent.parentExternalEntityAccessor = targetContent.externalEntityAccessor;
    return super.dropComponent(dropArea, targetContent, droppedContent, components, isNested);
  }

  handleUpdateSettings = (e) => {
    if (e.target.matches('[name="externalEntityAccessor"]')) {
      // When changing externalEntityAccessor, update it for all nested components
      AdaliaMEExternalEntityArray.nestedComponents(this.props.content).forEach((c) => {
        if (c.parentExternalEntityAccessor != e.target.value) {
          c.parentExternalEntityAccessor = e.target.value
          this.props.updateSettingsCallback(c.id, c, true);    
        }
      });
    }
    this.updateSettings(e);
  }

  renderView() {
    let rows = [];

    this.state.rows.forEach((rowId, i) => {
        let component = null;
        if (this.props.content.component) {
            component = Resolver.createElement(this.props.content.component.type, resolveComponentProps(this.props.content.component, this.props,  
              {
                selectCallback: this.props.selectCallback,
                selectedId: this.props.selectedId,
                prefillAnswers: this.prefillAnswers[rowId],
                repeatedFieldScope: this.props.content.name + '[row-' + i + ']',
                repeatedFieldRowIndex: i,
                externalEntityLinkingCallback: this.props.externalEntityLinkingCallback
              })
            );
        } else if (this.inEditMode) {
            component = <Helpers.DropArea componentId={this.props.content.id} />;
        }
        rows.push(
            <div key={rowId} className="component-row">
                <div className="component">
                    {component}
                </div>
            </div>
        );
    });

    return (
        <div>
            <label>{this.getText('label')}</label>
            {rows}
        </div>
    );
}

  renderSettings() {
      let validations = this.props.content.validations || {};

      return (
          <div>
              <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
            
              {this.props.externalEntityLinkingCallback &&
                      <Setting.ExternalEntityLinker 
                        name="externalEntityAccessor" 
                        label={I18n.t('field_external_entity_accessor', {scope: 'fe'})} 
                        value={this.props.content.externalEntityAccessor} 
                        onChange={this.handleUpdateSettings} 
                        description={I18n.t('field_external_entity_accessor_description', {scope: 'fe'})} 
                        externalEntityLinkingCallback={this.props.externalEntityLinkingCallback} 
                        endpoint={this.props.content.endpoint}
                      />
                    }


          </div>
      );
}



  addRow(event){

  }

  deleRow(event){

  }
}